module.exports = __webpack_public_path__ + "static/media/User_name.775e44a5.svg";